<template>
    <div>
        <div :class="{ 'bg-green-dark': style == 'success', 'bg-red-700': style == 'danger' }" class="bg-opacity-60" v-if="show && message">
            <div class="max-w-screen-xl mx-auto py-2 px-3 sm:px-6 lg:px-8">
                <div class="flex items-center justify-between flex-wrap">
                    <div class="w-0 flex-1 flex items-center min-w-0">
                        <span class="flex p-2 rounded-lg" :class="{ 'bg-green': style == 'success', 'bg-red-600': style == 'danger' }">
                            <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" v-if="style == 'success'">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>

                            <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" v-if="style == 'danger'">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                        </span>

                        <p class="ml-3 text-lg text-white truncate">
                            {{ message }}
                        </p>
                    </div>

                    <div class="flex-shrink-0 sm:ml-3">
                        <button
                            type="button"
                            class="-mr-1 flex p-2 rounded-md focus:outline-none sm:-mr-2 transition bg-gray-dark border-none"
                            :class="{ 'hover:bg-gray-darker focus:bg-gray-darker': style == 'success', 'hover:bg-red-600 focus:bg-red-600': style == 'danger' }"
                            aria-label="Dismiss"
                            @click.prevent="show = false">
                            <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                show: true,
            }
        },

        computed: {
            message() {
                console.log(this.$page.props.errors);
                
                if (this.$page.props.jetstream.flash?.banner) {
                    return this.$page.props.jetstream.flash?.banner;
                } else if (Object.keys(this.$page.props.errors).length > 0) {
                    return 'Please correct the errors shown below and try again.';
                } else {
                    return '';
                }
            },

            style() {
                if (Object.keys(this.$page.props.errors).length > 0) {
                    return 'danger';
                } else {
                    return this.$page.props.jetstream.flash?.bannerStyle || 'success';
                }
            },
        },

        methods: {
            flashTimeout () {
                setTimeout(() => {
                    this.show = false;
                }, 3000);
            }
        },

        mounted () {
            this.flashTimeout();
        },

        watch: {
            '$page.props.jetstream.flash' () {
                if (this.$page.props.jetstream.flash.banner) {
                    this.show = true;

                    this.flashTimeout();
                }
            },
            '$page.props.errors' () {
                console.log(this.$page.props.errors);
                if (Object.keys(this.$page.props.errors).length > 0) {
                    this.show = true;

                    this.flashTimeout();
                }
            }
        }
    }
</script>
